
import { ScrollArea } from "@/components/ui/scroll-area";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function CookiePolicy() {
  return (
    <div className="container max-w-4xl py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Cookie Policy</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-[600px] pr-4">
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold mb-3">1. What Are Cookies</h2>
                <p className="text-muted-foreground">
                  Cookies are small text files that are placed on your device when you visit our website. They help us improve your browsing experience, analyze site traffic, and personalize content.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">2. Types of Cookies We Use</h2>
                <p className="text-muted-foreground">
                  We use essential, analytical, and functional cookies to provide and improve our services. These include session cookies, persistent cookies, and third-party cookies.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">3. Purpose of Cookies</h2>
                <p className="text-muted-foreground">
                  Our cookies help us:
                  - Remember your login preferences
                  - Understand how you interact with our website
                  - Provide personalized content and recommendations
                  - Improve our website's performance and security
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">4. Managing Cookies</h2>
                <p className="text-muted-foreground">
                  You can control and manage cookies through your browser settings. Most browsers allow you to block, delete, or disable cookies. However, this may impact the functionality of our website.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">5. Third-Party Cookies</h2>
                <p className="text-muted-foreground">
                  We may use third-party services that set cookies for analytics, advertising, and other purposes. These third parties may also collect and use information about your online activities.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">6. Changes to Cookie Policy</h2>
                <p className="text-muted-foreground">
                  We may update this Cookie Policy from time to time. We encourage you to review this page periodically for any changes.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-3">7. Contact Us</h2>
                <p className="text-muted-foreground">
                  If you have any questions about our Cookie Policy, please contact us at cookies@chargeshare.com
                </p>
              </section>
            </div>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
}
